/**
 * Helper untuk menangkap informasi Browser / OS dan IP pengguna untuk Audit Logs
 */

let cachedIp: string | null = null;
let cachedAt = 0;
const IP_TTL_MS = 5 * 60 * 1000; // 5 menit — IP user mobile bisa berubah (WiFi → LTE)

export async function getClientIp(): Promise<string> {
  if (cachedIp !== null && Date.now() - cachedAt < IP_TTL_MS) return cachedIp;

  const fetchWithTimeout = async (url: string, ms = 2000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), ms);
    try {
      const res = await fetch(url, { signal: controller.signal, cache: "no-store" });
      clearTimeout(timer);
      return res;
    } catch {
      clearTimeout(timer);
      return null;
    }
  };

  try {
    // Gunakan Cloudflare trace bawaan domain (tanpa rate-limit & tanpa 3rd party)
    const resp = await fetchWithTimeout("/cdn-cgi/trace", 1500);
    if (resp && resp.ok) {
      const text = await resp.text();
      const match = text.match(/ip=(.+)/);
      if (match && match[1]) {
        cachedIp = match[1].trim();
        cachedAt = Date.now();
        return cachedIp;
      }
    }
  } catch (_e) {
    // Fallback jika di local dev tanpa Cloudflare
  }

  try {
    const resp = await fetchWithTimeout("https://api.ipify.org?format=json", 1500);
    if (resp && resp.ok) {
      const data = await resp.json();
      if (data.ip) {
        cachedIp = String(data.ip);
        cachedAt = Date.now();
        return cachedIp;
      }
    }
  } catch (_e) {
    // silent fail
  }

  return "Unknown IP";
}

export function getClientBrowserInfo(): string {
  if (typeof window === "undefined" || !navigator) return "Unknown Client";

  const ua = navigator.userAgent;
  let browser = "Browser";
  let os = "OS";

  // Deteksi OS
  if (/windows/i.test(ua)) os = "Windows";
  else if (/android/i.test(ua)) os = "Android";
  else if (/iphone|ipad|ipod/i.test(ua)) os = "iOS";
  else if (/macintosh|mac os x/i.test(ua)) os = "macOS";
  else if (/linux/i.test(ua)) os = "Linux";

  // Deteksi Browser
  if (/edg/i.test(ua)) browser = "Edge";
  else if (/chrome|crios/i.test(ua) && !/opr|edge/i.test(ua)) browser = "Chrome";
  else if (/firefox|fxios/i.test(ua)) browser = "Firefox";
  else if (/safari/i.test(ua) && !/chrome|crios/i.test(ua)) browser = "Safari";
  else if (/opr\//i.test(ua)) browser = "Opera";

  return `${browser} on ${os}`;
}
